import InteractionHistoryDialog from './InteractionHistoryDialog';

export default InteractionHistoryDialog ;